import React from 'react';
import SubLayout from '../../components/Layout/SubLayout'
import strings from "../../components/Language";
import { IconPlus, IconBank } from "../../components/Icons";
import "../Wallet/wallet.scss";

import _ from 'lodash';

import { toast } from 'react-toastify';
import axios from 'axios';
import { api } from '../../components/config/api.js';
import { getToken, storeUserData } from '../../components/Util';

import LoaderContext from '../../components/Loader/LoaderContext.js';
import moment from 'moment';

class BankScreen extends React.Component {

	static contextType = LoaderContext;

	constructor(props) {
		super(props);
		this.state = {
			access_token: "",
			user_data: {},
			data: []
		}
	}

	async componentDidMount() {
		var token = await getToken();
		if (token) {
			await storeUserData(token);
			this.setState({ access_token: token });
			setTimeout(() => {
				this.getData();
			});
		}
	}

	getData() {
		const { setLoading } = this.context;
		setLoading(true);
		var self = this;
		axios({
			method: 'GET',
			url: api.bank_report,
			headers: {
				'Authorization': 'Bearer ' + self.state.access_token,
				'Content-Type': 'application/json',
				'Accept-Language': strings.getLanguage()
			}
		}).then(function (ress) {
			if (ress.data.data && ress.data.data.length > 0) {
				self.setState({ data: ress.data.data });
			} else {
				if (ress.data.validation && ress.data.validation.length !== 0) {
					_.forEach(ress.data.validation, function (value) {
						if (value[0]) {
							toast.error(value[0]);
						}
					});
				} else {
					toast.error(ress.data.message);
				}
			}
			setLoading(false);
		}).catch(function (e) {
			setLoading(false);
		});
	};

	render() {
		return (
			<SubLayout data={{ "title": strings.Bank_Management }}>
				<div className='wl-page offset-md-4 col-md-4'>
					<div className='wl-toolbar wl-toolbar-end'>
						<button type="button" className='wl-link-chip is-primary' onClick={() => this.props.history.replace({ pathname: `/add-bank` })}>
							<IconPlus size={14} strokeWidth={2.4} />{strings.add}
						</button>
					</div>

					{this.state.data && this.state.data.length > 0 ?
						<ul className='wl-list'>
							{this.state.data.map((item, i) => (
								<li key={item.id || i} className={'wl-row' + (item.is_binded ? ' is-active' : '')}>
									<span className='wl-row-icon is-swap'><IconBank size={18} /></span>
									<span className='wl-row-main'>
										<span className='wl-row-title'>{item.bank_account_holder}</span>
										<span className='wl-row-sub wl-mono'>{item.bank_account_no ? item.bank_account_no.substr(item.bank_account_no.length - 10).replace(/.(?=.{5})/g, '*') : ''}</span>
									</span>
									<span className='wl-row-date'>{item.created_at ? moment(item.created_at).format("YYYY-MM-DD") : ''}</span>
								</li>
							))}
						</ul>
						: <div className='wl-empty'>{strings.no_records_found}</div>}
				</div>
			</SubLayout >
		);
	}
}

export default BankScreen;
